import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const SITE = "Jobfixnow";
export const SITE_URL = () => window.location.origin;
export const OG_IMAGE = () => `${SITE_URL()}/images/og-image.png`;
const clip = (s, n = 155) => (s.length <= n ? s : `${s.slice(0, n - 1).replace(/\s+\S*$/, "")}…`);

export function Seo({ title, description, path, noindex = false, jsonLd, type = "website", image, prev, next }) {
  const full = title ? `${title} | ${SITE}` : `${SITE} — We Find. You Grow.`;
  const url = `${SITE_URL()}${path ?? window.location.pathname}`;
  const desc = clip(description || "Jobfixnow is an all-industry job platform for India — jobs for freshers and experienced professionals, remote and on-site, across every industry.");
  const img = image || OG_IMAGE();
  const lds = (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).filter(Boolean);
  return (
    <>
      <title>{full}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {prev && <link rel="prev" href={`${SITE_URL()}${prev}`} />}
      {next && <link rel="next" href={`${SITE_URL()}${next}`} />}
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:locale" content="en_IN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {lds.map((ld, i) => <script key={i} type="application/ld+json">{JSON.stringify(ld)}</script>)}
    </>
  );
}

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org", "@type": "BreadcrumbList",
  itemListElement: [["Home", "/"], ...items].map(([name, p], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${SITE_URL()}${p}` })),
});

export function Breadcrumbs({ items, dark = false }) {
  const all = [["Home", "/"], ...items];
  return (
    <nav aria-label="Breadcrumb" className={`mb-4 text-xs ${dark ? "text-white/60" : "text-slate-500"}`} data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1">
        {all.map(([name, p], i) => (
          <li key={p} className="flex items-center gap-1">
            {i > 0 && <ChevronRight size={12} />}
            {i === all.length - 1 ? <span aria-current="page" className="font-medium">{name}</span> : <Link to={p} className="hover:text-[#00B94F]">{name}</Link>}
          </li>
        ))}
      </ol>
      <script type="application/ld+json">{JSON.stringify(breadcrumbLd(items))}</script>
    </nav>
  );
}
